import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow";
import { css } from "styled-components";

Object.assign(rfqQuoteDetailsQuoteLineCalculatorStyles, {
    ...rfqQuoteDetailsQuoteLineCalculatorStyles,
    startQtyTextField: {
        cssOverrides: {
            formField: css`
                width: 70px;
            `,
            inputSelect: css`
                border-radius: 8px;
                & :focus {
                    border-radius: 8px;
                }
            `,
        },
    },
    endQtyTextField: {
        cssOverrides: {
            formField: css`
                width: 70px;
            `,
            inputSelect: css`
                border-radius: 8px;
                & :focus {
                    border-radius: 8px;
                }
            `,
        },
    },
    priceTextField: {
        cssOverrides: {
            formField: css`
                width: 100px;
            `,
            inputSelect: css`
                text-align: right;
                border-radius: 8px;
                text-align: start;
                & :focus {
                    border-radius: 8px;
                }
            `,
        },
    },
    methodGridItem: { width: [7, 7, 6, 6, 6] },
    percentGridItem: {
        width: [3, 3, 4, 4, 4],
        align: "bottom",
    },
});
